import AstoundLogo from '../Assets/images/commonImages/logo.svg';

export const globalVal: any = {
    logo: AstoundLogo,
    long_name: 'Astound Mobile',
    short_name: 'Astound',
    primary_color: '#48688f',
    primary_font_color: '#48688f',
    primary_brand_color: '#009C86',
    white: '#ffffff',
    honey: '#eeab18',
    burnt_sienna: '#c06b14',
    blush: '#f79a91',
    dusk: '#48688f',
    lavender: '#a976a2',
    jade: '#3a8580',
    hubspot_is_test: process.env.REACT_APP_SERVER_NAME === 'astound-prod' ? false : true, // set "false" for production
    hubspot_is_qa: process.env.REACT_APP_SERVER_NAME === 'astound-prod' ? false : true,
    sorting_order: 'LH', // low to high - LH and hight to low -HL
    max_card_count: 4,
    max_line_count: 6,
    dev_hubSpot_id: process.env.REACT_APP_HUBSPOT_DEV_ID,
    prod_hubSpot_id: process.env.REACT_APP_HUBSPOT_PROD_ID,
    source: 'TMOBILE', // 'TELISPIRE'
    aws_url: process.env.REACT_APP_LP_CLOUDFRONT_URL,
    phoneNumber: '(800) 427-8686',
    support_time: 'Call us 9AM - 9PM EST',
    email: 'reach@reachmobile.com',
    REACH_INVITE_REFERRALS_BID_E: 'A528E96A9DD82CBC83DE6AAA8F31B801',
    REACH_INVITE_REFERRALS_BID: '26304',
    REACH_INVITE_REFERRALS_T: '420',
    REACH_INVITE_REFERRALS_CAMPAIGNID: '22558', //22851 for Dev // 22443 for QA // 22558 or 0 for production
    REACH_INVITE_REFERRALS_EVENT: 'register',
    REACH_INVITE_REFERRALS_URL: 'https://www.ref-r.com/campaign/t1/settings',
    encryption: 'WPA',
    hiddenSSID: false,
    bestFitPlans: ['Best Fit 15GB', 'Best Fit 10GB', 'Best Fit 5GB', 'Best Fit 2GB'],
    reachUrl: 'https://www.reachmobile.com',
    reachBestFitVideoUrl: 'https://youtu.be/91Kpfx24-2I',
    blogURL: 'https://connect.reachmobile.com/',
    unlockPhoneBlogURL:
        'https://learn.reachmobile.com/how-do-i-know-if-my-device-is-unlocked-how-can-i-unlock-my-device',
    IOSURL: 'https://apps.apple.com/us/app/astound-mobile/id6449095899',
    androidUrl: 'https://play.google.com/store/apps/details?id=com.astound.mobile.rcn',
    shopPhone: 'http://shop.reachmobile.com/phones',
    helpCenter: 'https://learn.reachmobile.com/',
    facebook: 'https://www.facebook.com/astoundbroadband',
    twitter: 'https://twitter.com/astoundconnects',
    instagram: 'https://www.instagram.com/astoundbroadband',
    youtube: 'https://www.youtube.com/@astoundbroadband',
    findIMEIUrl: '',
    imeiTwitterUrl: 'https://twitter.com/intent/tweet?',
    imeiFacebookUrl: 'https://www.facebook.com/dialog/share?app_id=2511315725603016&display=popup',
    careersUrl: 'https://go.reachmobile.com/careers',
    assuranceCardUrl:
        'https://assurance.sysnetgs.com/assurancecard/be8e7fbc4499573f7b885f0c5bc7bb258f94cab7bc94c687d719f355ed8ea026/assurancecard/',
    mspURL: 'https://services.moneysavingpro.com/v1/conversion/?pid=871&cid=',
    help_page: 'https://www.astound.com/support/mobile/',
};
